// extracted by css-extract-rspack-plugin
export default {"slot":"src-modules-auth-components-OtpSlot-OtpSlot-module__slot-jXfkdD","active":"src-modules-auth-components-OtpSlot-OtpSlot-module__active-Bl4_hD","loading":"src-modules-auth-components-OtpSlot-OtpSlot-module__loading-NwByCN","error":"src-modules-auth-components-OtpSlot-OtpSlot-module__error-YIXiv2"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"slot\":\"src-modules-auth-components-OtpSlot-OtpSlot-module__slot-jXfkdD\",\"active\":\"src-modules-auth-components-OtpSlot-OtpSlot-module__active-Bl4_hD\",\"loading\":\"src-modules-auth-components-OtpSlot-OtpSlot-module__loading-NwByCN\",\"error\":\"src-modules-auth-components-OtpSlot-OtpSlot-module__error-YIXiv2\"}";
        // 1793875576689
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  